import { NumberInput } from '@mantine/core';

/**
 * A version of NumberInput that disables the ability to increment/decrement
 * values using the arrow keys.
 */
const NonIncrementingNumberInput = ({
  innerRef,
  ...remainingProps
}: { innerRef?: React.RefObject<HTMLInputElement> } & Omit<
  React.ComponentProps<typeof NumberInput>,
  'step' | 'hideControls'
>) => {
  return (
    <NumberInput
      {...remainingProps}
      ref={innerRef}
      // Setting `step={0}` to disable the ability to increment/decrement
      // value using arrow keys. We've been seeing issues where the
      // originally-entered value changes by one or two cents by the time
      // the form is submitted. The theory is that the user is unintentionally
      // adjusting the value before moving to the next field.
      step={0}
      // These are the increment/decrement buttons on the left-hand side
      // of the input field. We've set the `step` to 0, so hiding these
      // buttons because they're useless.
      hideControls
      styles={{
        ...remainingProps.styles,
        control: {
          ...(remainingProps.styles as any)?.control,
          boxShadow: 'inherit',
          padding: 'inherit',
          margin: 'inherit',
          border: 'inherit',
          color: 'inherit',
        },
      }}
    />
  );
};

export default NonIncrementingNumberInput;
